module.exports =

  capitalizeFirstLetter: (string) ->
    return unless string
    return string.charAt(0).toUpperCase() + string.slice(1);

  normalizePhone: (number) ->
    return unless number
    return number.replace(/[^\d#*]/g, '')

  maskPhone: (number) ->
    return unless number
    result = @normalizePhone(number)
    size = result.length
    if size > 12
      result = result.replace(/^([\d#*][\d#*])([\d#*][\d#*])([\d#*]{5})([\d#*]{4})([\d*#]{0,5}).*/,"$1 $2 $3-$4$5")
    else if size > 8
      result = result.replace(/^([\d#*][\d#*])([\d#*][\d#*])([\d#*]{4})([\d#*]{0,4}).*/,"$1 $2 $3-$4")
    else if size > 4
      result = result.replace(/^([\d#*][\d#*])([\d#*][\d#*])([\d#*]{0,5})/,"$1 $2 $3")
    else if size > 2
      result = result.replace(/^([\d#*][\d#*])([\d#*]*)/, "$1 $2")
    result

  maskPhoneInput: (number) ->
    return '' unless number
    result = @normalizePhone(number)
    size = result.length

    if result.search(/^0/) > -1
      if size > 8
        result = result.replace(/^([\d#*]{4})([\d#*]{4})([\d#*]*)/, "$1-$2-$3")
      else if size > 4
        result = result.replace(/^([\d#*]{4})([\d#*]*)/, "$1-$2")
      return result

    if result.search(/^4/) > -1 && size <= 8
      if size > 4
        result = result.replace(/^([\d#*]{4})([\d#*]*)/, "$1-$2")
      return result

    if size > 10
      result = result.replace(/^([\d#*][\d#*])([\d#*][\d#*])([\d#*]{3})([\d#*]{0,8}).*/,"$1 $2$3-$4")
    else if size > 6
      result = result.replace(/^([\d#*][\d#*])([\d#*][\d#*])([\d#*]{2})([\d#*]{0,5}).*/,"$1 $2$3-$4")
    else if size > 2
      result = result.replace(/^([\d#*][\d#*])([\d#*]*)/, "$1 $2")
    result

  padLeft: (number, pad='00') ->
    pad.substring(0, pad.length - number.toString().length) + number.toString()



// WEBPACK FOOTER //
// ./src/helpers/masks.coffee